export default __webpack_public_path__ + "static/media/Group 4841 (2).36daeddf.svg";